// // Utility for advanced log filtering

// export function applyIntervalFilter(rowValue, condition) {
//   const match = condition.match(/^([<>]=?|=)\s*(\d+(\.\d+)?)/);
//   if (!match || rowValue == null) return false;
//   const [, operator, value] = match;
//   const numeric = parseFloat(value);
//   const actual = parseFloat(rowValue);
//   if (isNaN(actual)) return false;

//   switch (operator) {
//     case "<":
//       return actual < numeric;
//     case ">":
//       return actual > numeric;
//     case "=":
//       return actual === numeric;
//     case "<=":
//       return actual <= numeric;
//     case ">=":
//       return actual >= numeric;
//     default:
//       return false;
//   }
// }

// export function applyFieldFilters(row, filters, fieldDefs) {
//   return fieldDefs.every(({ key, type }) => {
//     const selected = filters[key];
//     if (!selected || selected.length === 0 || selected.includes("None")) return true;

//     const value = row[key];

//     if (type === "exact") {
//       return selected.includes(String(value));
//     } else if (type === "interval") {
//       return selected.some((rule) => applyIntervalFilter(value, rule));
//     }

//     return true;
//   });
// }

// export function isDateInRange(timestamp, from, to) {
//   const date = new Date(timestamp);
//   return (!from || date >= from) && (!to || date <= to);
// }

export function applyFieldFilters(row, filters, fieldDefs) {
  return fieldDefs.every(({ key, type }) => {
    const filter = filters[key];
    if (!filter || (typeof filter === "string" && filter === "")) return true;

    const value = parseFloat(row[key]);
    if (type === "exact") {
      return String(row[key]) === filter;
    }

    if (type === "interval") {
      const min = parseFloat(filter.min);
      const max = parseFloat(filter.max);
      if (!isNaN(min) && value < min) return false;
      if (!isNaN(max) && value > max) return false;
    }

    return true;
  });
}

export function isDateInRange(timestamp, from, to) {
  const date = new Date(timestamp);
  return (!from || date >= from) && (!to || date <= to);
}
